'use strict';
import 'rxjs/add/operator/combineLatest';
import fuse from '../../../_libs/redux-fusion';
import {assetTasksCtrlConfig} from '../../../tasks/router-asset-tasks';
import {ASSET_FILE_REQUIREMENT_COLLECTION} from '../../domain/config';
import {RequirementViewActivityContainer} from './RequirementViewActivityContainer';
import {RequirementViewActivityView} from './RequirementViewActivityView';


const StreamedComponent = RequirementViewActivityContainer({
  collection: ASSET_FILE_REQUIREMENT_COLLECTION,
  taskListState: assetTasksCtrlConfig.taskListState,
  taskDetailsState: assetTasksCtrlConfig.taskDetailsState,
});

export const AssetFileRequirementViewActivityContainer = fuse(StreamedComponent)(RequirementViewActivityView);

AssetFileRequirementViewActivityContainer.displayName = 'AssetFileRequirementViewActivity';



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewActivity/AssetFileRequirementViewActivityContainer.js